export default (args) => ({
    purchasableId: null,
    valid: true,
    variant: {},
    variantCount: args.variantCount ?? 1,
    options: [],
    error: null,

    init() {
        console.log('ARGS', args);
    },

    handleSelectVariant(variant) {
        this.variant = variant;
    },

    handleSubmit(event) {
        const self = this;

        // reset errors
        self.valid = true;
        self.error = null;

        // submit the form via ajax
        const form = event.target;
        const formData = new URLSearchParams(new FormData(form));

        // make the request, make sure to send cookies
        fetch('/', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json',
            },
            credentials: 'same-origin',
        })
        .then(response => response.json())
        .then(data => {
            if (data.errors && Object.keys(data.errors).length > 0) {
                self.valid = false;
                self.error = Object.values(data.errors).shift();
                return;
            }

            // reset the options
            self.options = [];

            const components = document.getElementsByClassName('cart-qty-component');
            for (let i = 0; i < components.length; i++) {
                htmx.trigger(components[i], 'refreshCartQty');
            }

            // send the add to cart event
            htmx.trigger(document.body, 'cart-added');
        });
    }
})
